// @ts-nocheck
import React from 'react'
import { get } from 'lodash'
import { FormFieldLayout, FormInput } from '../../../generic'
import { InputDatePicker } from '@lmc/ui-kit'
import dayjs from 'dayjs'

type DateFieldProps = {
  displayCalendar: boolean
  errors: any
  formFieldStyle: any
  formKey: any
  futureDate: boolean
  onChange: any
  showAge: boolean
  placeholder: any
  style: any
  age: any
  values: any
  children: any
  readOnly: boolean
  disabled: boolean
}

export default function DateField({
  displayCalendar,
  errors,
  formFieldStyle,
  formKey,
  futureDate = true,
  onChange,
  placeholder,
  style,
  values,
  children,
  readOnly,
  disabled,
  ...props
}: DateFieldProps) {
  const error = get(errors, formKey)
  const value = get(values, formKey)
  return (
    // @ts-ignore
    <FormFieldLayout hasErrors={!!error} style={formFieldStyle} {...props}>
      {!readOnly && displayCalendar ? (
        <InputDatePicker
          futureDate={futureDate}
          onChange={(date, dateString) => {
            onChange({ key: formKey, value: dateString })
          }}
          value={value}
          defaultValue={value && dayjs(value, 'DD-MM-YYYY')}
        />
      ) : (
        <div style={{ display: 'flex' }}>
          <div
            style={{
              flex: value ? 1 : null,
              marginRight: value ? 15 : null,
              width: '100%',
              ...style,
            }}
          >
            <FormInput
              error={error}
              format
              onChange={(e) => {
                onChange({ key: formKey, value: e.target.value })
              }}
              options={{
                date: true,
                delimiter: '-',
                datePattern: ['d', 'm', 'Y'],
              }}
              readOnly={readOnly}
              placeholder={placeholder}
              value={value}
              disabled={disabled}
              data-testid={props['data-testid']}
            />
          </div>
          {children}
        </div>
      )}
    </FormFieldLayout>
  )
}
